// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"style__modalFooter__My0Ym","marginBottom":"style__marginBottom__WPpR0"};